<!-- <app-card [card]="card"></app-card> -->
<!--<div id="emoji-box" #emojiBox></div>-->
<!--<app-emojis [container]="emojiBox"></app-emojis>-->
<app-card-wrapper
  [title]="'In your opinion, what could make microlearning effective compared to traditional methods?'">
  <app-word-cloud [phrases]="phrases"></app-word-cloud>
</app-card-wrapper>
